<template>
  <div class="month">
    <div class="hd">
      <div class="img">
        <img :src="cover" alt="" />
      </div>
    </div>
    <ul class="month-list clearfix">
      <li v-for="item in matchList" :key="item.id">
        <router-link :to="'/detail/' + item.id">
          <div :class="['pic',item.is_wait?'pic-wait':'']">
            <img :src="item.image" />
            <div class="wait-text" v-if="item.is_wait">赛事待开启</div>
          </div>
          <div class="txt">
            <div class="h">{{ item.mname }}</div>
            <div class="p">{{ item.sponsor }}</div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cover: "",
      id: this.$route.params.id,
      matchList: [
        // {
        //   link: "",
        //   img: require("@/static/res/images/pscase_before5.jpg"),
        //   title: "标题标题标题标题标题标题",
        //   subTitle: "主办：几十块较好的333"
        // }
      ],
    };
  },
  methods: {
    init() {
      // this.axios.post("/match/getMoonMatchList?id=" + this.id).then(res => {
      this.axios
        .post("/match/getMoonMatchList", { id: this.id })
        .then((res) => {
          // console.log("xxxxL", res.data.data.info.image);
          this.cover = res.data.data.info.image;
          this.matchList = res.data.data.list;
        });
    },
  },
  created() {
    this.init();
      var data = {url:window.location.href,id:this.id};
      this.tools.wx_share_init(data);
  },
};
</script>

<style lang="scss">
.img,
.img img {
  width: 100%;
}
.month .hd img {
  width: 100%;
}
.month-list li {
  float: left;
  width: 356px;
  margin: 13px 0 0 13px;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 0 3px rgba(50, 50, 50, 0.5);
  p {
    box-sizing: border-box;
    padding: 0 10px;
    word-wrap: break-word;
    word-break: break-all;
  }
  .txt {
    height: 133px;
  }
  .h {
    font-size: 24px;
    color: #333;
    line-height: 36px;
    max-height: 72px;
    margin-top: 5px;
    overflow: hidden;
  }
  .p {
    font-size: 20px;
    color: #888;
    line-height: 36px;
    height: 36px;
    margin: 10px 0;
  }
  & .img,
  & img {
    width: 100%;
    height: 179px;
  }
  .pic-wait{
    position: relative;
    img{
      filter:blur(8px)
    }
    .wait-text{
      width:60%;
      height:100px;
      position:absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background:rgba(255,255,255,.2);
      text-align: center;
      line-height: 100px;
      color: #fff;
      font-size: 30px;
      text-shadow: 0 0 10px rgba(0,0,0,.7);
    }
  }
}
</style>
